import React from 'react';
import PropTypes from 'prop-types';
import { SAFE_ZINDEX, readOnlyText } from '@constants/mui-theme';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import * as colors from '@constants/colors';

const useStyles = makeStyles(() => ({
  select: props => ({
    color: colors.dotmapsBlack80,
    marginLeft: '0.5rem',
    '&:focus': {
      backgroundColor: 'transparent',
      color: colors.dotmapsBlack80
    },
    '&.Mui-disabled': {
      ...readOnlyText
    },
    ...props.selectStyles?.root
  }),
  icon: {
    '&.Mui-disabled': {
      color: colors.dotmapsBlack40
    }
  }
}));

const CustomSelect = props => {
  const { selectStyles = { root: {}}, ...other } = props;
  const classes = useStyles({ selectStyles });

  return (
    <Select
      {...other}
      classes={{
        select: classes.select,
        icon: classes.icon
      }}
    />
  );
};

CustomSelect.propTypes = {
  selectStyles: PropTypes.object
};

const SelectField = ({
  children, id, labelId, onChange, renderValue, value, ...other
}) => (
  <CustomSelect
    {...other}
    id={id}
    labelId={labelId}
    onChange={onChange}
    renderValue={renderValue}
    value={value}
    MenuProps={{
      style: SAFE_ZINDEX
    }}
  >
    {children}
  </CustomSelect>
);

SelectField.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  labelId: PropTypes.string,
  onChange: PropTypes.func,
  renderValue: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SelectField;
